import { DrawerStackState, DrawerStackAction, DrawerItem } from './types';

export const drawerStackReducer = (state: DrawerStackState, action: DrawerStackAction): DrawerStackState => {
  switch (action.type) {
    case 'PUSH_DRAWER': {
      const newDrawer = {
        ...action.payload,
        level: state.stack.length,
        timestamp: Date.now(),
      };
      
      return {
        ...state,
        stack: [...state.stack, newDrawer],
      };
    }
    
    case 'POP_DRAWER': {
      if (state.stack.length === 0) return state;
      
      return {
        ...state,
        stack: state.stack.slice(0, -1),
      };
    }
    
    case 'REPLACE_DRAWER': {
      if (state.stack.length === 0) {
        // If no drawers, just push
        const newDrawer = {
          ...action.payload,
          level: 0,
          timestamp: Date.now(),
        };
        return {
          ...state,
          stack: [newDrawer],
        };
      }
      
      // Replace the last drawer
      const newDrawer = {
        ...action.payload,
        level: state.stack.length - 1,
        timestamp: Date.now(),
      };
      
      return {
        ...state,
        stack: [...state.stack.slice(0, -1), newDrawer],
      };
    }
    
    case 'CLOSE_DRAWER': {
      return {
        ...state,
        stack: state.stack.filter(drawer => drawer.id !== action.payload),
      };
    }
    
    case 'CLOSE_ALL': {
      return {
        ...state,
        stack: [],
      };
    }
    
    default:
      return state;
  }
};
